import * as WallabyCoreSchema from './_generated/wallaby_core_schema';

export type LabResultEventTypeV3Dto = WallabyCoreSchema.components['schemas']['LabResultEventTypeV3Dto'];

export type LabMethodNamePartsInput = {
  eventType: string;
  label?: string | null;
  unit?: string | null;
};

const bracket = (value: string | null | undefined): string | null => {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim();
  return trimmed.length === 0 ? null : `[${trimmed}]`;
};

// Format a lab-method name for filter options and chart legends. Spec:
//   <hospital specific label> [<unit>] [<lab method code>]   — when label is present
//   [<lab method code>] [<unit>]                              — when label is absent
// Brackets are part of the rendered name. Missing optional segments collapse.
export function formatLabMethodName({eventType, label, unit}: LabMethodNamePartsInput): string {
  const code = bracket(eventType);
  const unitBracket = bracket(unit);
  if (label && String(label).trim().length > 0) {
    return [String(label).trim(), unitBracket, code].filter(Boolean).join(' ');
  }
  return [code, unitBracket].filter(Boolean).join(' ');
}

export type LabMethodTypeMap = Record<string, LabResultEventTypeV3Dto>;

export function indexLabMethodTypes(types: LabResultEventTypeV3Dto[] | undefined | null): LabMethodTypeMap {
  const map: LabMethodTypeMap = {};
  (types ?? []).forEach((t) => {
    if (t?.eventType) map[t.eventType] = t;
  });
  return map;
}
